import {Breakpoints, DrawerRefState} from './types'

export const DEFAULT_BREAKPOINTS: Record<Breakpoints, number> = {
  [Breakpoints.FULL]: 0, // полноразмерная шторка
  [Breakpoints.LARGE]: 0.4, // большая шторка
  [Breakpoints.MEDIUM]: 0.6, // средняя шторка(станадртная)
  [Breakpoints.MINIMUM]: 0.8, // слегка видная шторка
  [Breakpoints.HIDDEN]: 1.2, // спрятанная шторка за пределами экрана
}

export const INITIAL_DRAWER_REF_STATE: DrawerRefState = {
  movable: true,
  moved: false,
}

// Отступ
export const GAP_BETWEEN_HEADER = 0.1
